import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export const EnquiryModal = ({ open, service, onClose }) => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (open) setForm({ name: "", email: "", message: "" });
  }, [open]);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/enquiries", {
        ...form,
        type: service ? "service" : "contact",
        service: service || null,
      });
      toast.success("Enquiry received. Our desk replies within 24 hours.");
      onClose();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setSending(false);
    }
  };

  const field =
    "bg-[var(--ekal-bg)] border-white/15 text-slate-100 placeholder:text-slate-600 focus-visible:ring-[var(--ekal-accent)] rounded-none";

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent
        data-testid="enquiry-modal"
        className="bg-[#12151C] border-white/15 text-slate-100 rounded-none sm:max-w-lg"
      >
        <DialogHeader>
          <p className="text-[10px] font-mono uppercase tracking-[0.25em] text-amber-400">Enquiry Desk</p>
          <DialogTitle className="font-heading font-extrabold uppercase tracking-tight text-2xl">
            {service || "General Enquiry"}
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 pt-2">
          <Input
            data-testid="enquiry-name-input"
            required
            placeholder="Your name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className={field}
          />
          <Input
            data-testid="enquiry-email-input"
            required
            type="email"
            placeholder="Email address"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className={field}
          />
          <Textarea
            data-testid="enquiry-message-input"
            required
            rows={4}
            placeholder="Tell us about the game, the brand, or the frame you need…"
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
            className={field}
          />
          <button
            data-testid="enquiry-submit-btn"
            type="submit"
            disabled={sending}
            className="w-full bg-[var(--ekal-accent)] hover:bg-red-600 disabled:opacity-60 text-white text-xs font-mono uppercase tracking-[0.2em] px-5 py-4 transition-colors"
          >
            {sending ? "Sending…" : "Send Enquiry"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
